import React from "react";
import { iconsEnum } from "../UiComponents/IconSelect";

export default function CategoryIcon({ category, size = 38 }) {
  const color = category?.color?.value ?? "#6c757d";
  const iconSize = size * 0.5;

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: `2px solid ${color}`,
      }}
    >
      <i
        className={`campicon-${iconsEnum[category?.icon]}`}
        style={{
          color: color,
          fontSize: iconSize,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      />
    </div>
  );
}
